module.exports = __webpack_public_path__ + "assets/img/warrior-name-56c717fd.png";